<template>
  <div
    class="createLogin"
    :class="{
      styleChanged:
        showError.logIn && showError.password && showError.replyPassword,
    }"
  >
    <button class="goBack" @click="goBack()">
      <i class="fas fa-chevron-left"></i>
      {{ $t("authorization.back") }}
    </button>
    <form @submit.prevent="goSendPassport">
      <div class="input-fields">
        <input
          @input="checkFields()"
          type="text"
          :placeholder="$t('authorization.login')"
          v-model="initModel.username"
        />
        <label for=""> {{ $t("authorization.needLogin") }} </label>
        <small v-for="(item, index) in errormessage.username" :key="index">
          {{ item }}
        </small>
        <svg
          v-if="showError.logIn"
          width="30"
          height="28"
          viewBox="0 0 30 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M29.7137 24.1033L16.829 1.78645C16.4473 1.12521 15.7635 0.730469 15 0.730469C14.2365 0.730469 13.5527 1.12521 13.171 1.78645L0.286348 24.1033C-0.0954492 24.7645 -0.0954492 25.5541 0.286348 26.2152C0.668086 26.8765 1.35182 27.2712 2.11535 27.2712H27.8846C28.6482 27.2712 29.3319 26.8765 29.7137 26.2152C30.0954 25.5541 30.0954 24.7645 29.7137 24.1033ZM28.1895 25.3353C28.1516 25.401 28.0614 25.5113 27.8847 25.5113H2.11535C1.93852 25.5113 1.8484 25.4011 1.81055 25.3353C1.77264 25.2696 1.72213 25.1364 1.81055 24.9833L14.6951 2.66641C14.7836 2.5133 14.9241 2.49039 14.9999 2.49039C15.0759 2.49039 15.2164 2.51324 15.3047 2.66641L28.1895 24.9833C28.2779 25.1364 28.2274 25.2696 28.1895 25.3353Z"
            fill="#D34D4D"
          />
          <path
            d="M15.8803 8.73242H14.1203V18.119H15.8803V8.73242Z"
            fill="#D34D4D"
          />
          <path
            d="M14.9993 22.2256C15.6473 22.2256 16.1726 21.7003 16.1726 21.0522C16.1726 20.4042 15.6473 19.8789 14.9993 19.8789C14.3513 19.8789 13.8259 20.4042 13.8259 21.0522C13.8259 21.7003 14.3513 22.2256 14.9993 22.2256Z"
            fill="#D34D4D"
          />
        </svg>
      </div>
      <div class="password-fields">
        <div class="input">
          <input
            @input="checkFields"
            :type="show.passwordHint ? 'text' : 'password'"
            :placeholder="$t('authorization.newPassword')"
            v-model="initModel.password"
          />
          <div
            class="showPassword"
            @click="show.passwordHint = !show.passwordHint"
          >
            <i class="fas fa-eye-slash" v-if="!show.passwordHint"></i>
            <i class="fas fa-eye" v-if="show.passwordHint"></i>
          </div>
          <label for="">
            {{ $t("authorization.passwordLength") }}
          </label>
          <small v-if="showError.password">
            {{ $t("authorization.showPassword") }}
          </small>
        </div>

        <svg
          v-if="showError.password"
          width="30"
          height="28"
          viewBox="0 0 30 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M29.7137 24.1033L16.829 1.78645C16.4473 1.12521 15.7635 0.730469 15 0.730469C14.2365 0.730469 13.5527 1.12521 13.171 1.78645L0.286348 24.1033C-0.0954492 24.7645 -0.0954492 25.5541 0.286348 26.2152C0.668086 26.8765 1.35182 27.2712 2.11535 27.2712H27.8846C28.6482 27.2712 29.3319 26.8765 29.7137 26.2152C30.0954 25.5541 30.0954 24.7645 29.7137 24.1033ZM28.1895 25.3353C28.1516 25.401 28.0614 25.5113 27.8847 25.5113H2.11535C1.93852 25.5113 1.8484 25.4011 1.81055 25.3353C1.77264 25.2696 1.72213 25.1364 1.81055 24.9833L14.6951 2.66641C14.7836 2.5133 14.9241 2.49039 14.9999 2.49039C15.0759 2.49039 15.2164 2.51324 15.3047 2.66641L28.1895 24.9833C28.2779 25.1364 28.2274 25.2696 28.1895 25.3353Z"
            fill="#D34D4D"
          />
          <path
            d="M15.8803 8.73242H14.1203V18.119H15.8803V8.73242Z"
            fill="#D34D4D"
          />
          <path
            d="M14.9993 22.2256C15.6473 22.2256 16.1726 21.7003 16.1726 21.0522C16.1726 20.4042 15.6473 19.8789 14.9993 19.8789C14.3513 19.8789 13.8259 20.4042 13.8259 21.0522C13.8259 21.7003 14.3513 22.2256 14.9993 22.2256Z"
            fill="#D34D4D"
          />
        </svg>
      </div>
      <div class="reply-fields">
        <div class="input">
          <input
            @input="checkFields"
            :type="show.replyPasswordHint ? 'text' : 'password'"
            :placeholder="$t('authorization.replyNewPassword')"
            v-model="initModel.replyPassword"
          />
          <div
            class="showPassword"
            @click="show.replyPasswordHint = !show.replyPasswordHint"
          >
            <i class="fas fa-eye-slash" v-if="!show.replyPasswordHint"></i>
            <i class="fas fa-eye" v-if="show.replyPasswordHint"></i>
          </div>
        </div>
        <small v-if="showError.replyPassword">
          {{ $t("authorization.passwordMismatch") }}
        </small>
        <svg
          v-if="showError.replyPassword"
          width="30"
          height="28"
          viewBox="0 0 30 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M29.7137 24.1033L16.829 1.78645C16.4473 1.12521 15.7635 0.730469 15 0.730469C14.2365 0.730469 13.5527 1.12521 13.171 1.78645L0.286348 24.1033C-0.0954492 24.7645 -0.0954492 25.5541 0.286348 26.2152C0.668086 26.8765 1.35182 27.2712 2.11535 27.2712H27.8846C28.6482 27.2712 29.3319 26.8765 29.7137 26.2152C30.0954 25.5541 30.0954 24.7645 29.7137 24.1033ZM28.1895 25.3353C28.1516 25.401 28.0614 25.5113 27.8847 25.5113H2.11535C1.93852 25.5113 1.8484 25.4011 1.81055 25.3353C1.77264 25.2696 1.72213 25.1364 1.81055 24.9833L14.6951 2.66641C14.7836 2.5133 14.9241 2.49039 14.9999 2.49039C15.0759 2.49039 15.2164 2.51324 15.3047 2.66641L28.1895 24.9833C28.2779 25.1364 28.2274 25.2696 28.1895 25.3353Z"
            fill="#D34D4D"
          />
          <path
            d="M15.8803 8.73242H14.1203V18.119H15.8803V8.73242Z"
            fill="#D34D4D"
          />
          <path
            d="M14.9993 22.2256C15.6473 22.2256 16.1726 21.7003 16.1726 21.0522C16.1726 20.4042 15.6473 19.8789 14.9993 19.8789C14.3513 19.8789 13.8259 20.4042 13.8259 21.0522C13.8259 21.7003 14.3513 22.2256 14.9993 22.2256Z"
            fill="#D34D4D"
          />
        </svg>
      </div>

      <button
        :disabled="!initModel.username || !initModel.password || !initModel.replyPassword"
        type="submit"
        class="step"
      >
        {{ $t("authorization.continue") }}
      </button>
      <button class="mainPage">{{ $t("authorization.mainPage") }}</button>
    </form>
  </div>
</template>

<script>
import { reactive } from "vue";
import { useStore } from "vuex";
import { unique } from "@/network/v1";

export default {
  /*  eslint-disable */
  setup(props, { emit }) {
    /* eslint-enable */
    const store = useStore();

    let initial = true;

    const initModel = reactive({
      username: "",
      password: "",
      replyPassword: "",
    });

    const show = reactive({
      passwordHint: false,
      replyPasswordHint: false,
    });

    const showError = reactive({
      logIn: false,
      password: false,
      replyPassword: false,
    });

    const errormessage = reactive({});
    let emailVerified = false;

    const goSendPassport = () => {
      initial = false;
      checkFields();
      checkPassworLength();
      checkConfirmPassword();

      const formData = new FormData();
      formData.append("username", initModel.username);

      unique(
        () => {
          emailVerified = true;
        },
        formData,
        async (res) => {
          const checker = await res.json();
          for (const name in checker) {
            errormessage[name] = checker[name];
          }
          emailVerified = false;
        }
      );
      if (!emailVerified) return;

      if (showError.logIn || showError.password || showError.replyPassword) {
        return;
      }

      emit("submitForm");
    };

    const checkConfirmPassword = () => {
      const userModel = store.getters.userModel;

      if (userModel.password != initModel.replyPassword) {
        return (showError.replyPassword = true);
      }
    };

    const checkPassworLength = () => {
      if (initModel.password.length < 6) {
        return (showError.password = true);
      } else {
        console.log("success");
      }
    };

    const checkFields = () => {
      store.commit("updateUserModel", {
        username: initModel.username,
        password: initModel.password,
      });
      if (initial) return;

      const userModel = store.getters.userModel;

      showError.logIn = !userModel.username || userModel.username.length === 0;
      showError.password =
        !userModel.password || userModel.password.length === 0;
      showError.replyPassword =
        !initModel.replyPassword || initModel.replyPassword.length === 0;
    };

    const goBack = () => {
      emit("goBack");
    };

    return {
      show,
      initModel,
      goSendPassport,
      checkFields,
      showError,
      checkConfirmPassword,
      checkPassworLength,
      goBack,
      errormessage,
    };
  },
};
</script>

<style lang="scss" scoped>
.createLogin {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  .goBack {
    color: var(--explanation-color);
    background: transparent;
    font-size: 1.1em;
    line-height: 1.2em;
    margin-left: 2rem;
    margin-top: 1rem;
  }
  form {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    .input-fields {
      display: grid;
      grid-template-areas:
        "input svg"
        "explanation explanation"
        "warning warning";
      grid-template-columns: 20rem 1rem;
      margin-top: 3.4rem;
      width: 21rem;
      input {
        grid-area: input;
        height: 3.4rem;
        font-size: 1.1em;
        line-height: 1.2em;
        font-weight: 400;
        outline: none;
        background: var(--input-bg);
        border: var(--input-border);
        padding: 0 1.2rem;
        ::placeholder {
          font-size: 1em;
          line-height: 1.2em;
          font-weight: 300;
        }
        &:focus {
          background: var(--input-focus-bg);
          box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.03);
        }
        &:focus ~ label {
          display: block;
        }
      }
      .togglePassword {
        grid-area: showPassword;
        display: flex;
        color: var(--back-btn);
      }
      label {
        grid-area: explanation;
        color: var(--explanation-color);
        font-size: 1em;
        line-height: 1.2em;
        font-weight: 300;
        margin-top: 0.4rem;
        display: none;
      }
      small {
        grid-area: warning;
        color: var(--warning-danger);
        font-size: 1em;
        line-height: 1.2em;
        padding-top: 0.5rem;
      }
      svg {
        grid-area: svg;
        margin-top: auto;
        margin-bottom: auto;
        margin-left: 1rem;
      }
    }
    .password-fields {
      display: grid;
      grid-template-areas:
        "password warningSvg"
        "newPassword newPassword";
      margin-top: 3.4rem;
      height: 5rem;
      align-items: center;
      width: 21rem;
      .input {
        grid-area: password;
        display: grid;
        grid-template-areas:
          "input showPassword"
          "areaLabel areaLabel"
          "shortPassword shortPassword";
        position: relative;
        grid-template-columns: 18.9rem 1rem;
        align-items: center;

        height: 3.4rem;
        border: var(--input-border);
        background: var(--input-bg);

        input {
          width: 100%;
          height: 3.2rem;
          padding: 0 1.3rem;
          background: var(--input-bg);
          outline: none;
          grid-area: input;
          &:focus ~ label {
            display: block;
          }
          &:focus {
            background: #fefefe;
            box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.03);
          }
        }
        &:focus-within {
          background: white;
        }
        &:focus-within ~ label {
          background: white;
          display: block;
        }
        .showPassword {
          display: flex;
          align-items: center;
          justify-content: center;
          grid-area: showPassword;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 0;
          i {
            color: var(--back-btn);
            width: 1.875rem;
            height: 1.875rem;
            display: flex;
            align-items: center;
            cursor: pointer;
          }
        }
        small {
          grid-area: shortPassword;
          color: var(--warning-danger);
          margin-top: 0.5rem;
        }
        label {
          grid-area: newPassword;
          color: var(--explanation-color);
          margin-top: 0.313rem;
          display: none;
          grid-area: areaLabel;
        }

        &:focus ~ label {
          display: block;
        }
      }

      svg {
        grid-area: warningSvg;
        margin-left: 1rem;
      }
      &:focus ~ label {
        display: block;
      }
    }
    .reply-fields {
      display: grid;
      grid-template-areas:
        "password svg"
        "shortPassword shortPassword";
      grid-template-columns: 20rem 1rem;
      width: 21rem;
      margin-top: 3.4rem;
      .input {
        grid-area: password;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 3.4rem;
        border: var(--input-border);
        background: var(--input-bg);
        input {
          width: 100%;
          height: 3.2rem;

          padding: 0 1.3rem;
          background: var(--input-bg);
          outline: none;
          grid-area: input;
          &:focus {
            background: #fefefe;
            box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.03);
          }
        }
        .showPassword {
          display: flex;
          align-items: center;
          justify-content: center;
          grid-area: showPassword;
          i {
            color: var(--back-btn);
            width: 1.875rem;
            height: 1.875rem;
            display: flex;
            align-items: center;
            cursor: pointer;
          }
        }
        &:focus-within {
          background: white;
        }
      }

      small {
        grid-area: shortPassword;
        color: var(--warning-danger);
        margin-top: 0.5rem;
      }
      svg {
        grid-area: svg;
        margin-left: 1rem;
        margin-top: auto;
        margin-bottom: auto;
      }
      &:focus ~ label {
        display: block;
      }
    }
    .step {
      font-size: 1.5em;
      line-height: 0.8em;
      font-weight: 400;
      color: var(--explanation-color);
      border: 2px solid #6c8fba;
      background: transparent;
      outline: none;
      width: 17rem;
      height: 3.7rem;
      margin-left: auto;
      margin-right: auto;
      margin-top: 2.5rem;
      cursor: pointer;
      &:disabled {
        opacity: 0.5;
        pointer-events: none;
      }
    }
    .mainPage {
      font-size: 1.2em;
      line-height: 1.2em;
      background: transparent;
      color: var(--back-btn);
      border-bottom: 1px solid rgba(128, 128, 128, 1);
      margin-bottom: 3rem;
      margin-top: 1rem;
    }
  }
}

@media screen and (max-width: 540px) {
  .createLogin {
    .goBack {
      margin-left: 1rem;
    }
    form {
      .input-fields {
        grid-template-columns: 14rem 1rem;
        width: 15rem;
        input {
          height: 2.813rem;
        }
        label,
        small {
          font-size: 0.75em;
          line-height: 1.1em;
        }
      }
      .password-fields {
        width: 15rem;
        .input {
          grid-template-columns: 12.8rem 1rem;
          height: 2.8rem;
          input {
            height: 2.6rem;
          }
          label,
          small {
            font-size: 0.75em;
            line-height: 1.1em;
          }
        }
      }
      .reply-fields {
        grid-template-columns: 13.8rem 1rem;
        width: 15rem;
        .input {
          height: 2.8rem;
          input {
            height: 2.6rem;
          }
        }
        small {
          font-size: 0.75em;
          line-height: 1.1em;
        }
      }
    }
  }
}
</style>
